// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import './override.css'
import * as firebase from 'firebase'
export const eventbus = new Vue()
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    firebase.initializeApp({
      // apiKey: 'AIzaSyAkcMjqQAYWRv337RY4nm_ri04BgFbaOVA',
      // authDomain: 'insideinsightstaples.firebaseapp.com',
      // databaseURL: 'https://insideinsightstaples.firebaseio.com',
      // projectId: 'insideinsightstaples',
      // storageBucket: 'insideinsightstaples.appspot.com',
      // messagingSenderId: '425019635202'
      apiKey: 'AIzaSyB7Q9aVWCQn4BOb6VACeHAqT8IB4aXiU8k',
      authDomain: 'campus-recruitment-test.firebaseapp.com',
      databaseURL: 'https://campus-recruitment-test.firebaseio.com',
      projectId: 'campus-recruitment-test',
      storageBucket: 'campus-recruitment-test.appspot.com',
      messagingSenderId: '203618709866'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js